/**
 * Merges source data into every column of the matching schema,
 * based on `source.integration.schema === schema.name`.
 *
 * @param {Array} sources   - Array of source objects.
 * @param {Array} dbSchemas - Array of schema objects (the big JSON).
 * @returns {Array} A *new* array of schema objects, with merged data.
 */
const mergeSourcesIntoColumns = (sources, dbSchemas) => {
  // Make a deep clone so we don't mutate the original input
  const newDB =
    typeof structuredClone === 'function'
      ? structuredClone(dbSchemas)
      : JSON.parse(JSON.stringify(dbSchemas));

  // Iterate over each source
  sources.forEach((source) => {
    const schemaName = source.integration?.schema;
    if (!schemaName) return; // skip if schema is missing
    if (!source.sourceIsActive) return; // skip if source is inactive

    // Find the matching schema object by name
    const matchingSchema = newDB.find((schemaObj) => schemaObj.name === schemaName);
    if (!matchingSchema) return; // no match found in dbSchemas
    // For each view in matchingSchema.views
    Object.keys(matchingSchema.views).forEach((viewKey) => {
      const view = matchingSchema.views[viewKey];

      // For each column in that view
      view.columns = view.columns.map((col) => ({
        ...col,
        source
      }));
    });
  });

  return newDB;
};

export { mergeSourcesIntoColumns };
